"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Templates {
}
exports.Templates = Templates;
//# sourceMappingURL=Templates.js.map